import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { Mail } from "lucide-react";

export const Footer = () => {
  const { t } = useTranslation();
  const cols = [
    {
      title: t("footer.shop"),
      links: [
        { label: t("categories.action_figures"), to: "/shop?category=Action%20Figure", testId: "action-figure" },
        { label: t("categories.toys"), to: "/shop?category=Toys", testId: "toys" },
        { label: t("categories.limited"), to: "/shop?category=Limited%20Editions", testId: "limited-editions" },
        { label: t("categories.merch"), to: "/shop?category=Merchandise", testId: "merchandise" },
      ],
    },
    {
      title: t("footer.brand"),
      links: [
        { label: t("footer.manifesto"), to: "/manifesto", testId: "manifesto" },
        { label: t("footer.drop_club"), to: "/drop-club", testId: "drop-club" },
        { label: t("footer.lookbook"), to: "/lookbook", testId: "lookbook" },
        { label: t("footer.contact"), to: "/contatti", testId: "contatti" },
      ],
    },
    {
      title: t("footer.help"),
      links: [
        { label: t("footer.shipping"), to: "/spedizioni", testId: "spedizioni" },
        { label: t("footer.returns"), to: "/resi", testId: "resi" },
        { label: t("footer.auth"), to: "/autenticita", testId: "autenticita" },
        { label: "FAQ", to: "/faq", testId: "faq" },
      ],
    },
  ];

  return (
    <footer data-testid="footer-section" className="bg-black text-white pt-20 pb-8 border-t-4 border-yellow-400">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 mb-16">
          <div className="md:col-span-5 space-y-6">
            <div className="flex items-center gap-3">
              <img
                src="/brand/logo-128.png"
                alt="Daita 'n' Jack"
                className="w-14 h-14 object-contain drop-shadow-[0_0_10px_rgba(250,204,21,0.3)]"
              />
              <div className="leading-none">
                <div className="font-heading text-3xl uppercase">DAITA<span className="text-yellow-400">&apos;N&apos;</span>JACK</div>
                <div className="font-jp text-xs text-zinc-500 tracking-widest mt-1">大太とジャック</div>
              </div>
            </div>
            <p className="text-zinc-400 max-w-md leading-relaxed">{t("footer.tagline")}</p>
            <div className="flex gap-3">
              {/* Social handles will be enabled once the shop publishes real URLs.
                  Only e-mail is exposed for now via a valid mailto: link. */}
              <a
                key="Email"
                href="mailto:daitanjackreloaded@gmail.com"
                data-testid="social-email"
                aria-label="Email"
                className="bg-zinc-900 border-2 border-zinc-800 hover:border-yellow-400 hover:bg-yellow-400 hover:text-black text-yellow-400 p-3 transition"
              >
                <Mail className="w-5 h-5" strokeWidth={3} />
              </a>
            </div>
          </div>

          {cols.map((c) => (
            <div key={c.title} className="md:col-span-2">
              <h4 className="font-heading uppercase text-yellow-400 text-lg mb-4 tracking-widest">{c.title}</h4>
              <ul className="space-y-2">
                {c.links.map((l) => (
                  <li key={l.label}>
                    <Link
                      to={l.to}
                      data-testid={`footer-link-${l.testId}`}
                      className="text-zinc-400 hover:text-yellow-400 transition text-sm"
                    >
                      {l.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div className="md:col-span-1 hidden md:flex items-center justify-center">
            <div className="font-jp text-yellow-400/30 text-6xl rotate-90 origin-center whitespace-nowrap select-none">漫画</div>
          </div>
        </div>

        <div className="border-t-2 border-zinc-900 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-zinc-500 text-xs uppercase tracking-widest">{t("footer.copyright")}</p>
          <div className="flex items-center gap-4 flex-wrap justify-center">
            <a
              href="https://www.digitalformula.it"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-digitalformula"
              className="text-zinc-500 hover:text-yellow-400 text-xs uppercase tracking-widest transition"
            >
              by <span className="font-heading tracking-wider">Digitalformula</span>
            </a>
            <a href="/admin/login" data-testid="admin-link" className="text-zinc-600 hover:text-yellow-400 text-xs uppercase tracking-widest transition">
              {t("footer.admin")}
            </a>
            <p className="text-zinc-600 text-xs uppercase tracking-widest font-jp">{t("footer.made_in")}</p>
          </div>
        </div>
      </div>
    </footer>
  );
};
